import renderMathInElement from 'katex/dist/contrib/auto-render'

const KatexPlugin = {
    install(app, globalOptions = {}) {
        app.directive('katex', {
            mounted(el, binding) {
                if (binding.arg === 'auto') {
                    const opts = binding.value?.options ?? binding.value ?? {}
                    renderMathInElement(el, { ...globalOptions, ...opts })
                }
            },
            updated(el, binding) {
                if (binding.arg === 'auto') {
                    const opts = binding.value?.options ?? binding.value ?? {}
                    renderMathInElement(el, { ...globalOptions, ...opts })
                }
            },
        })
    },
}

export default KatexPlugin
